// extracted by mini-css-extract-plugin
export default {"regions":"YAXdR","regions-group":"cK5Oa","region-list":"j31AA","region-list__item":"mvg60","region-list__link":"Fsm6L","group-title":"vRrf4"};